import { Node } from '@tiptap/core';
import { pastePlugin } from "@/models/Plugins/PastePlugin";

export const PasteFile = (callBack) => {
  return Node.create({
    name: 'attachment',
    inline: true,
    group: 'inline',
    draggable: true,

    addAttributes() {
      return {
        src: {},
        href: {},
        id: {},
        alt: { default: null },
        info: { default: "{}" },
        title: { default: null },
        isResizable: { default: true },
        type: { default: 'img' },
      }
    },

    addProseMirrorPlugins() {
      return [pastePlugin(callBack)];
    },
  });
};
